import { ReactNode } from 'react';
import { makeStyles } from '@mui/styles';
import { type Theme, LinearProgress, Paper, Typography } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    backgroundColor: 'rgb(0, 0, 0, 0.5)',
    height: '100%',
    left: 0,
    position: 'absolute',
    top: 0,
    width: '100%',
    zIndex: 1200,
  },
  label: {
    paddingBottom: 10,
    textAlign: 'center',
  },
  modal: {
    borderRadius: 24,
    left: '50%',
    padding: 40,
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,

    [theme.breakpoints.down('md')]: {
      left: '5%',
      right: '5%',
      transform: 'translate(0, -50%)',
      width: 'auto',
    },
  },
}), { name: 'IndeterminateLoading' });

export type IndeterminateLoadingProps = {
  label?: ReactNode;
};

const IndeterminateLoading = ({
  label,
}: IndeterminateLoadingProps): JSX.Element | null => {
  const classes = useStyles();

  if (!label) {
    return null;
  }

  return (
    <div className={classes.container}>
      <Paper className={classes.modal}>
        <div className={classes.label}>
          <Typography variant="h2">{label}</Typography>
        </div>
        <LinearProgress color="primary" />
      </Paper>
    </div>
  );
};

export default IndeterminateLoading;
